import './ccf-call-record-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfCallRecordIconProps extends SvgIconProps {}

/**
 * Component displays call record  svg icon 
 * @param props -CcfCallRecordIconProps
 * @returns call record svg icon
 * @example - <CcfCallRecordIcon/>
 */
export function CcfCallRecordIcon(props: CcfCallRecordIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Record">
    <rect width="20" height="20" fill="none"/>
    <g id="Group_119158" data-name="Group 119158" transform="translate(-766 -378)">
      <g id="recordEllipse4739" data-name="Ellipse 4739" transform="translate(766 378)" fill="none" stroke="currentcolor" strokeWidth="2">
        <circle cx="10" cy="10" r="10" stroke="none"/>
        <circle cx="10" cy="10" r="9" fill="none"/>
      </g>
      <circle id="Ellipse_4740" data-name="Ellipse 4740" cx="5.238" cy="5.238" r="5.238" transform="translate(770.762 382.762)"/>
    </g>
  </g>
    </SvgIcon>
  );
}

export default CcfCallRecordIcon;
